/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-process-type',
  templateUrl: './process-type.component.html',
  styleUrls: ['./process-type.component.scss'],
})
export class ProcessTypeComponent  implements OnInit {

  
  
  constructor() { }

  isActive = false;
  @Input() processTypes:any;


  ngOnInit() {
 
    

  }

  processTypeLabel:any=""

  get matchedCount(): number {
    return this.processTypes.filter((type: { matched: any; }) => type.matched).length;
  }

  get totalCount(): number {
    return this.processTypes.length;
  }

}


